










































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class AboCard extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isLoggedIn!: boolean
  @Prop({ type: Boolean, default: false })
  readonly hasValidSubscription!: boolean
}
